import React, { useState, useRef } from 'react';
import { Modal, Button, ProgressBar, Alert, Form } from 'react-bootstrap';
import { uploadFileAndStartImport } from '../services/uploadService';
import 'bootstrap/dist/css/bootstrap.min.css';

const StoreImporterModal = ({ projectId }) => {
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [isDone, setIsDone] = useState(false);
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const eventSourceRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    setError(null);
    setProgress(null);
    setIsDone(false);

    try {
      await uploadFileAndStartImport(
        projectId,
        file,
        eventSourceRef,
        (data) => setProgress(data), // onProgress
        () => setIsDone(true),      // onDone
        (errMsg) => setError(errMsg) // onError
      );
    } catch (err) {
      setError('Upload or import failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <Button variant='secondary' onClick={() => setShow(true)}>Import Stores</Button>

      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Import Stores CSV</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(!progress) && (
            <>
              <Form.Group controlId="formFile">
                <Form.Label>Select CSV File</Form.Label>
                <Form.Control type="file" accept=".csv" onChange={handleFileChange} disabled={uploading} />
              </Form.Group>

              <Button
                variant="primary"
                className="mt-3"
                onClick={handleUpload}
                disabled={!file || uploading}
              >
                {uploading ? 'Uploading...' : 'Upload & Start Import'}
              </Button>
            </>
          )}

          {error && <Alert variant="danger" className="mt-3">❌ {error}</Alert>}

          {progress && (() => {
            const { processed = 0, failed = 0, duplicates = 0, remaining = 0 } = progress || {};
            const total = processed + failed + duplicates + remaining;
            const completed = processed + failed + duplicates;
            const percent = total > 0 ? (completed / total) * 100 : 0;

            return (
              <div className="mt-4">
                <p>✅ Processed: {processed}</p>
                <p>🟡 Duplicates: {duplicates}</p>
                <p>❌ Failed: {failed}</p>
                <p>⏳ Remaining: {remaining}</p>
                <div className="position-relative" style={{ height: '30px' }}>
                  <ProgressBar
                    now={percent}
                    striped
                    animated
                    variant="success"
                    style={{ height: '100%' }}
                  />
                  <div
                    className="position-absolute w-100 text-center"
                    style={{
                      top: 0,
                      left: 0,
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'black', // Ensure visibility even on light backgrounds
                      fontWeight: 'bold',
                    }}
                  >
                    {Math.round(percent)}%
                  </div>
                </div>
              </div>
            );
          })()}

          {isDone && progress && (
            <div className="mt-4">
              <h5>Final Report</h5>
              <p><strong>Failed Rows:</strong> {progress.failedRows?.join(', ') || 'None'}</p>
              <p><strong>Duplicate Rows:</strong> {progress.duplicateRows?.join(', ') || 'None'}</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StoreImporterModal;
